<div class="container">
  <h1>{{'LOGOUT_TITLE'|translate}}</h1>
  <p>{{'LOGOUT_SUCCESS'|translate}}</p>
</div>